module.exports = __webpack_public_path__ + "media/images/sidebar-pop-post-fe6e0f849e1c7ba244c1538993fa42dd.png";